import { View, ViewModel } from "binder"
import { FormBuilderComponentView } from "src/formBuilder/structure/element";
import { ITemplateSelector } from "src/uicomponents/components/templateSelector";
import { ContentElement } from "./content-viewModel"

export class ContentView extends FormBuilderComponentView<ContentElement>{
    GetViewUniqueId(): string {
        return "V-85E5006D-2224-4700-A991-CBC6788B5746"
    }
    loadHtml(): string {
        let element = require('./content.html').default;
        let style = require('./content.less');
        return element;
    }
    constructor() {
       super();
    }

    public set Content(v: ViewModel) { this._Content = v; } public get Content(): ViewModel { return this._Content;} private _Content: ViewModel;
    public set TemplateSelector(v: ITemplateSelector) { this._TemplateSelector = v; } public get TemplateSelector(): ITemplateSelector { return this._TemplateSelector;} private _TemplateSelector: ITemplateSelector;
    public set ItemTemplateSelector(v: string) { this._ItemTemplateSelector = v; } public get ItemTemplateSelector(): string { return this._ItemTemplateSelector;} private _ItemTemplateSelector: string;

}
